import { z } from "zod";

export const citySchema = z.object({
	id: z.string().optional(),
	name: z.string().nullable().optional(),
	code: z.string().nullable().optional(),
	province_code: z.string().optional(),
	created_at: z.string().optional(),
	updated_at: z.string().optional(),
});

export type City = z.infer<typeof citySchema>;
